import React from 'react';

const SkeletonCard: React.FC = () => (
    <div className="bg-white rounded-xl p-3 mb-2 border border-slate-200 shadow-sm animate-pulse">
        <div className="flex items-start justify-between gap-2 mb-2">
            <div className="flex items-center gap-2 flex-1">
                <div className="w-2 h-2 rounded-full bg-slate-200" />
                <div className="h-3 bg-slate-200 rounded w-3/4" />
            </div>
            <div className="w-5 h-5 rounded-full bg-slate-200" />
        </div>
        <div className="h-2 bg-slate-100 rounded w-1/2 mb-2" />
        <div className="flex items-center gap-1.5 mb-2">
            <div className="h-3 w-8 bg-slate-100 rounded" />
            <div className="h-3 w-6 bg-slate-100 rounded" />
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-slate-100">
            <div className="h-2 bg-slate-100 rounded w-1/3" />
            <div className="h-2 bg-slate-100 rounded w-12" />
        </div>
    </div>
);

const SkeletonColumn: React.FC<{ gradient: string; rows?: number }> = ({ gradient, rows = 2 }) => (
    <div className="flex flex-col bg-gradient-to-b from-slate-50 to-slate-100/80 backdrop-blur rounded-xl min-h-[400px] w-full min-w-[200px] flex-shrink-0 border border-slate-200/60 shadow-sm">
        <div className={`bg-gradient-to-br ${gradient} opacity-60 px-3 py-3 rounded-t-xl`}>
            <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-lg bg-white/30 animate-pulse" />
                    <div className="h-3 w-20 bg-white/40 rounded animate-pulse" />
                </div>
                <div className="w-7 h-5 bg-white/30 rounded animate-pulse" />
            </div>
        </div>
        <div className="flex-1 p-2">
            {Array.from({ length: rows }).map((_, i) => (
                <SkeletonCard key={i} />
            ))}
        </div>
    </div>
);

export const TableroSkeleton: React.FC = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
        <SkeletonColumn gradient="from-slate-500 to-slate-600" rows={2} />
        <SkeletonColumn gradient="from-blue-500 to-blue-600" rows={3} />
        <SkeletonColumn gradient="from-amber-500 to-amber-600" rows={2} />
        <SkeletonColumn gradient="from-orange-500 to-orange-600" rows={1} />
        <SkeletonColumn gradient="from-purple-500 to-purple-600" rows={2} />
        <SkeletonColumn gradient="from-emerald-500 to-emerald-600" rows={3} />
    </div>
);

export default TableroSkeleton;